module.exports = __webpack_public_path__ + "static/media/sogou.bd5b5716.png";